import EStyleSheet from "react-native-extended-stylesheet";
import { Platform } from "react-native";

export const styles = EStyleSheet.create({
  background: {
    width: "100%",
    height: Platform.OS === "web" ? "100vh" : "100%",
    justifyContent: "center",
    overflow: "hidden",
  },
});
